@custom-media --mobile (max-width: 768px);

.searchContainer {
  margin-bottom: 1em;
}

.searchButton {
  margin-left: auto;

  &::after {
    font-size: 1.5em;
  }
}

.searchForm {
  display: none;

  &.visible {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  @media (--mobile) {
    flex-direction: column;
  }
}
